import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
/********************************************************************************
 * Copyright (c) 2019 TypeFox and others
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
import { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { toLocalTime } from '../../../utils';
import { UserPublisherAgreement } from './user-publisher-agreement';
import { MainContext } from '../../../context';
import { DetailRow, DetailsCard } from '../../../components/details-card';
import { UserAvatar } from '../../../components/user-avatar';
import { MediaSidebarLayout } from '../../../components/media-sidebar-layout';
import { SettingsHeader } from '../settings/settings-header';
export const UserSettingsProfile = ({ user, isAdmin }) => {
    const { pageSettings } = useContext(MainContext);
    let publisherAgreementPanel = null;
    if (user.publisherAgreement) {
        if (isAdmin) {
            let statusText = 'has not signed';
            if (user.publisherAgreement.status === 'signed') {
                statusText = 'has signed';
            }
            else if (user.publisherAgreement.status === 'revoked') {
                statusText = 'has a revoked signature of';
            }
            else if (user.publisherAgreement.status === 'outdated') {
                statusText = 'has signed an outdated version of';
            }
            const publisherAgreementName = pageSettings?.publisherAgreement?.name ?? '';
            publisherAgreementPanel = (_jsxs(Typography, { variant: 'body1', sx: { mt: '1.125rem' }, title: toLocalTime(user.publisherAgreement.timestamp), children: [user.loginName, " ", statusText, " the ", publisherAgreementName, " Publisher Agreement."] }));
        }
        else {
            publisherAgreementPanel = _jsx(UserPublisherAgreement, { user: user });
        }
    }
    return (_jsxs(Box, { children: [_jsx(SettingsHeader, { title: 'Profile' }), _jsxs(MediaSidebarLayout, { sidebar: _jsx(UserAvatar, { user: user, sx: {
                        width: '100%',
                        height: 'auto',
                        aspectRatio: '1 / 1',
                        borderRadius: theme => `${theme.shape.borderRadiusCard}px`,
                        border: '1px solid',
                        borderColor: 'divider',
                        fontSize: '3.5rem'
                    } }), children: [_jsxs(DetailsCard, { children: [_jsx(DetailRow, { label: 'Login name', mono: true, children: user.loginName }), user.fullName ? _jsx(DetailRow, { label: 'Full name', children: user.fullName }) : null] }), publisherAgreementPanel] })] }));
};
//# sourceMappingURL=user-settings-profile.js.map